<template>
  <!-- 选择标签 -->
  <div>
    <!-- 点击选择 -->
    <div>
      <span class="title-style"
            v-if="showTitle">{{titleName}}: </span>

      <!-- 选择标签： -->
      <el-tag class="select-tag-area"
              ref="tag_list"
              size="small"
              @click.native="selectType(item)"
              v-for="item in tag_list"
              :key="item.tag_id"
              :type="buttonType(item)"
              effect="plain">
        {{ item.tag_name }}
      </el-tag>

    </div>
    <!-- 添加标签 -->
    <div v-if="creatNewTag"
         class="add-tag-button">
      <el-input class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="mini"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm">
      </el-input>
      <el-button v-else
                 class="button-new-tag"
                 size="mini"
                 @click="showInput">+ 创建一个标签</el-button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'select-name',
  data() {
    return {
      tag_list: this.tagList,
      selectList: [],
      inputVisible: false,
      inputValue: '',
      buttonType: (item) => {
        if (this.selectList.indexOf(item) == -1) {
          return 'info'
        } else {
          return ''
        }
      },
      inputVisible: false,
      inputValue: '',
    }
  },
  props: {
    tagChecked: {
      type: Array,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    titleName: {
      type: String,
      default: '标签',
    },
    tagList: Array,
    creatNewTag: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    tagList(newValue) {
      this.tag_list = newValue
    },
    selectList(newValue) {
      this.selectList = newValue
    },
  },
  mounted() {
    // console.log(this.$refs.tag_list)
  },
  methods: {
    // 点击 选择标签 时
    selectType(item) {
      // 判断改id是否在 已选列表中
      if (this.selectList.indexOf(item) == -1) {
        // 如不在，放进去
        this.selectList.push(item)
        this.buttonType(item)
      } else {
        // 如果在，拿出来
        let item_index = this.selectList.indexOf(item)
        this.selectList.splice(item_index, 1)
        this.buttonType(item)
      }
      this.$emit('getSelectList', this.selectList)
    },
    handleInputConfirm() {
      // 发出事件
      if (this.inputValue == '') {
        this.$message({
          message: '标签不能为空',
          type: 'warning',
        })
        this.inputVisible = false
        return
      }
      let new_tag_name = this.inputValue
      this.$emit('addNewTagToTagList', new_tag_name)
      this.inputVisible = false
      this.inputValue = ''
      // let inputValue = this.inputValue
      // if (inputValue) {
      //   this.tagList.push(inputValue)
      // }
      //
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
  },
}
</script>

<style>
.title-style {
  font-size: 15px;
  margin-right: 10px;
  padding: 5px;
}

.add-tag-button {
  margin-top: 20px;
  text-align: left;
}
.show-tag-area {
  margin-bottom: 20px;
}
.select-tag-area {
  cursor: pointer;
  margin-right: 10px;
  margin-top: 5px;
}
.button-new-tag {
  margin-left: 0px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 120px;
  margin-left: 0px;
  vertical-align: bottom;
}
</style>